export default "__VITE_ASSET__ea5ea499__"